
export const getSections = ({ sectionsReducer: { sections = [] } = {} }) => sections;
export const getSectionFilter = ({ sectionsReducer: { filter = {} } = {} }) => filter;
export const getSectionsCount = ({ sectionsReducer: { count = 0 } = {} }) => count;
